module.exports = __webpack_public_path__ + "img/logo.ebbc65dc.png";